export const splitStringArray = (
  array: string[],
  separator: string | RegExp = /[,;]/
) =>
  array
    .flatMap((values) =>
      values
        .split(separator)
        .map((value) => value.trim())
        .filter(Boolean)
    )
    .filter((values) => values.length > 0);
